import { SERVICES } from "../../data/content";
import { Reveal } from "./Reveal";

const ACCENT = {
  teal: { background: "rgba(43,182,160,0.08)", borderColor: "rgba(43,182,160,0.2)", color: "var(--accent-teal)" },
  purple: { background: "rgba(188,140,255,0.08)", borderColor: "rgba(188,140,255,0.2)", color: "var(--accent-purple)" },
  gold: { background: "var(--gold-glow)", borderColor: "rgba(212,160,23,0.2)", color: "var(--gold)" },
};

export const Services = () => (
  <section className="section section--dark" id="services" aria-labelledby="services-heading">
    <div className="container">
      <div className="section-header">
        <div className="section-label">What I Offer</div>
        <h2 className="section-heading" id="services-heading">Professional <em>Services</em></h2>
        <p className="section-sub">
          From inception design to final knowledge products — I provide decision-grade evidence services
          that drive funding, adaptation, and policy outcomes.
        </p>
      </div>
      <div className="services-grid">
        {SERVICES.map((s, i) => {
          const Icon = s.icon;
          const accent = s.accent ? ACCENT[s.accent] : null;
          return (
            <Reveal className="service-card" key={s.title} delay={(i % 3) * 80} data-testid={`service-card-${i}`}>
              <div className="service-icon-wrap" style={accent ? { background: accent.background, borderColor: accent.borderColor } : undefined}>
                <Icon size={24} style={accent ? { color: accent.color } : undefined} />
              </div>
              <div className="service-title">{s.title}</div>
              <div className="service-desc">{s.desc}</div>
              <div className="service-methods">
                {s.methods.map((m) => <span key={m} className="method-tag">{m}</span>)}
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
